// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"IconButton_scroll-black__NSptr","button_circle":"IconButton_button_circle__cORue","indicator":"IconButton_indicator__9GF0a"};